import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import { isMobile } from 'common/helpers';
import Hotel from './Hotel';
import HotelMobile from './HotelMobile';
import { PartnerHotels as S } from './../styles';

class Hotels extends React.Component {
  state = {
    sort: 'id',
    order: 'asc',
    options: [
      {
        name: 'Select an option',
        value: 'id',
      },
      {
        name: 'Distance (closest walk to venue)',
        value: 'distance',
      },
      {
        name: 'Stars (highest first)',
        value: 'rating',
      },
      {
        name: 'Price (cheapest first)',
        value: 'price',
      },
    ],
  };
  handleSort = (event) => {
    const key = event.target.value;
    if (key === 'rating') {
      this.setState({ sort: key, order: 'desc' });
    } else {
      this.setState({ sort: key, order: 'asc' });
    }
  }
  renderHotel = (hotel) => {
    const hotelProps = {
      key: hotel.name,
      hotel,
      modal: this.props.modal,
      selectedHotel: this.props.selectedHotel,
    };
    return (
      isMobile() ?
        (
          <HotelMobile {...hotelProps} />
        )
        : (
          <Hotel {...hotelProps} />
        )
    );
  }
  render() {
    const { sort, order, options } = this.state;
    const hotels = orderBy(this.props.hotels, sort, order);
    return (
      <S.Hotels>
        <S.Bar>
          <h3>Official SWC Partner Hotels</h3>
          <div>
            <h3>Sort by:</h3>
            <select onChange={this.handleSort}>
              { options.map((option) => (
                <option key={option.name} value={option.value}>{option.name}</option>
              )) }
            </select>
          </div>
        </S.Bar>
        <S.List>
          { hotels.map((hotel) => (
            hotel.featured ? null : this.renderHotel(hotel)
          )) }
        </S.List>
        <p><span className="asterisk">*</span> {isMobile() ? (<em>Pricing approximate. You will pay in the hotel&apos;s local currency (THB).</em>) : 'Pricing approximate in subject to exchange rates. You will pay in the hotel\'s local currency (THB)'}</p>
      </S.Hotels>
    );
  }
}

Hotels.propTypes = {
  modal: PropTypes.func.isRequired,
  hotels: PropTypes.array.isRequired,
  selectedHotel: PropTypes.func.isRequired,
};

export default Hotels;



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels/Hotels.js